import React, { useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { usePreloadImg } from 'shared/hooks/usePreloadImg';
import { Input, ModalWithIconAndTimer, Toast } from 'shared/ui';
import warningIcon from 'styles/images/icon_t_warning.svg';

import { useSendNonMemberChgCncl, useSuspenseNonMemberPtInfo } from '../model/query';

import { Error } from './Error';

export const Body = () => {
  const [searchParams] = useSearchParams();
  const hspId = searchParams.get('hspId');
  const hspCd = searchParams.get('hspCd');
  const acptNo = searchParams.get('acptNo');
  const chgCnclType = searchParams.get('chgCnclType');
  const uuid = searchParams.get('uuid');
  const [isSubmit, setIsSubmit] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [usedSubmit, setUsedSubmit] = useState(false);
  const [isPopupBtn, setIsPopupBtn] = useState(false);
  const inputRef = useRef(null);
  const {
    data: {
      data: { result, failMsg, ptNm, ptNo, ptBrdy },
    },
  } = useSuspenseNonMemberPtInfo({ hspId, hspCd, acptNo, chgCnclType });

  const { refetch: refetchChgCncl, data: sendData } = useSendNonMemberChgCncl({
    hspId,
    hspCd,
    acptNo,
    chgCnclType,
    ptNo,
    uuid,
  });
  const [warningImg] = usePreloadImg(warningIcon);

  const typeText = chgCnclType === 'chg' ? '변경' : '취소';

  const handleSubmit = () => {
    if (usedSubmit) return;
    setUsedSubmit(true);
    (async () => {
      const inputValue = inputRef.current.value;
      if (inputValue.length === 8) {
        if (ptBrdy != inputValue) {
          setShowToast(true);
          return;
        }
        await refetchChgCncl();
        setIsSubmit(true);
      } else {
        setUsedSubmit(false);
        setIsInvalid(true);
      }
    })();
  };

  if (result === '1') return <Error />;

  return (
    <div className='container-wrap non-member'>
      <div className='content-area'>
        {/* title-top */}
        <div className='title-area'>
          <h2 className='header-tit-02'>
            정보보호를 위한 환자 정보 확인 후<br />
            예약 {typeText} 요청이 가능해요
          </h2>
          <span className='sub-tit-01'>
            환자의 생년월일을 입력해 주세요. <br />
            입력하신 정보가 환자정보와 동일한지 확인 후 예약
            <br />
            {typeText} 요청을 병원으로 보내드려요.
          </span>
        </div>

        {/* content */}
        <div className='main-content-area'>
          <div className='user-box'>
            {/* 가입정보 */}
            <ul className='user-info-list'>
              <li>
                <span className='title'>이름</span>
                <span className='content'>{ptNm}</span>
              </li>
              <li>
                <span className='title'>환자정보</span>
                <span className='content'>{ptNo}</span>
              </li>
            </ul>
          </div>

          {/* 생년월일 */}
          <div className='user-info-birth'>
            <span className='title'>생년월일</span>
            <Input ref={inputRef} isInvalid={isInvalid} setIsInvalid={setIsInvalid} />
          </div>
        </div>

        {/* bottom fixed btn */}
        <div className='btm-area gradient-btm'>
          <button className='btn btm-btn-primary' onClick={handleSubmit}>
            <span className='btn-txt-01'>예약 {typeText} 요청</span>
          </button>
        </div>
      </div>
      {isSubmit && (
        <ModalWithIconAndTimer
          type={sendData?.data?.result == 0 ? 'success' : 'fail'}
          title={
            sendData?.data?.result == 0
              ? sendData?.data?.cnclSucsYn == 'Y'
                ? '요청이 처리되었어요'
                : '요청이 접수되었어요'
              : '요청 접수가 실패되었어요'
          }
          contents={
            sendData?.data?.result == 0 ? (
              sendData?.data?.cnclSucsYn == 'Y' ? (
                <>
                  환자 정보 확인이 완료되어
                  <br />
                  진료예약 취소 요청 처리가 완료되었어요.
                </>
              ) : (
                <>
                  환자 정보 확인이 완료되어
                  <br />
                  진료예약 {typeText} 요청이 접수되었어요.
                </>
              )
            ) : (
              <>
                예약 {typeText} 요청이 실패되었어요
                <br />
                다시 확인 부탁드려요
              </>
            )
          }
          close={() => {
            try {
              if (!isPopupBtn) {
                setIsPopupBtn(true);
                window.location.replace(sendData?.data?.redirectURL);
              }
            } catch (err) {
              setIsSubmit(false);
              setUsedSubmit(false);
            }
          }}
          time={3000}
        />
      )}
      {showToast && (
        <Toast
          icon={warningImg}
          dissolve={true}
          close={() => {
            setShowToast(false);
            setUsedSubmit(false);
          }}
          text='환자정보가 일치하지 않아요.'
        />
      )}
    </div>
  );
};
